module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('strong', [_vm._v("Approximations of the Pronunciation of Names and Words")])]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/01.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("AK-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SEL")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/02.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("BEST-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EH-MOOR")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("GRANDMOTHER")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/03.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("DROWG")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("WATER CREATURE")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/04.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("ES-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PEN")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/05.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("FAR")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FATHER")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/06.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("FYORD")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("AN INLET OF THE SEA BETWEEN HIGH CLIFFS")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/07.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("GOOST")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/08.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("HAWK-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ON")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/09.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("HI")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("HELLO")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/10.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("HEERD")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("NORWEGIAN NAZI STORM TROOPERS")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/11.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("HYAL-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("MER")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/12.jpg"
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("HUL")]), _vm._v("-DRA")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TROLL HAG")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/13.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("VEP-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SEN")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE "), _c('em', [_vm._v("WASP")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/14.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("ING-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("GRID")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/15.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("YA")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YES")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/16.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("YENS")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/17.jpg"
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("YO-TUN")]), _vm._v("-HEIM-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("LAND OF THE GIANTS")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/18.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("SHELL")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/19.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("CRONE/CRO-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NER")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CROWN/CROWNS: NORWEGIAN MONEY")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/20.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("LIFE")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/21.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("LIL-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LE-BEE")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/22.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("MOOR")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("MOTHER")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/23.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("NIE")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("NO")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/24.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("NISS-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EH-LU-EH")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("RED STOCKING HAT")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/25.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("OH-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEH")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/26.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("PEAR")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/27.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("RAHG-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NA")]), _vm._v("-ROK")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("FINAL DESTRUCTION IN NORSE MYTHOLOGY")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/28.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("SOL-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VAY")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/29.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("TAHN-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEH MA")]), _vm._v("-REE")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("AUNT MARIE")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/30.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("TOOS-"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EN")]), _vm._v(" TUCK")]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("A THOUSAND THANKS")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/31.jpg"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("VAIR "), _c('span', {
    staticClass: "small"
  }, [_vm._v("SO GO")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "small"
  }, [_vm._v("BE SO GOOD; HELP YOURSELF")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 75
// module chunks = 0